<template>
  <div class="section-header mb-2">
    <!-- first row -->
    <div
      style="
        min-height: 5.5rem;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      "
    >
      <ButtonLeftArrow @click="onBack" />
      <h1
        style="
          line-height: 2rem;
          color: #174169;
          font-size: 1.5rem;
          white-space: normal;
          overflow-wrap: break-word;
          overflow: hidden;
          hyphens: auto;
        "
      >
        {{
          currState === STATES.EDITING
            ? (isAdding ? "新增" : "編輯") + (isBlog ? " Blog Post" : " EDM")
            : title
        }}
      </h1>
      <div style="flex: 1"></div>

      <template v-if="role === 'admin'">
        <!-- admin VIEWING button group desktop view -->
        <template v-if="currState === STATES.VIEWING && !isMobile">
          <ButtonEdit variant="outline-primary" style="white-space: nowrap" @click="onEdit">
            編輯
          </ButtonEdit>
          <ButtonRemove
            variant="outline-danger"
            style="white-space: nowrap"
            @click="prepareAction('REMOVE', '你已移除這個紀錄')"
          >
            移除
          </ButtonRemove>
        </template>

        <!-- admin EDITING button group -->
        <template v-else-if="currState === STATES.EDITING">
          <!-- desktop view -->
          <template v-if="!isMobile">
            <BaseButton
              v-if="!isAdding"
              style="width: 4rem; justify-content: center; white-space: nowrap"
              variant="outline-secondary"
              @click="onCancel"
            >
              取消
            </BaseButton>
            <BaseButton
              style="width: 7.5rem; justify-content: center; white-space: nowrap"
              variant="primary"
              @click="onSubmit"
            >
              {{ isDraft ? "儲存草稿" : "預覽及提交" }}
            </BaseButton>
          </template>

          <!-- mobile view -->
          <template v-else>
            <BaseButton class="p-0" variant="none" @click="onSubmit">
              <div style="min-width: 4rem; display: flex; flex-direction: column">
                <img src="@/assets/img/icon/mobile-more.svg" height="36" alt="more" />
                <span style="color: #3596F4; font-size: 0.75rem; white-space: nowrap">
                  {{ isDraft ? "儲存草稿" : "預覽及提交" }}
                </span>
              </div>
            </BaseButton>
          </template>
        </template>

        <!-- admin PREVIEWING button group -->
        <template v-else-if="currState === STATES.PREVIEWING">
          <!-- desktop view -->
          <template v-if="!isMobile">
            <BaseButton
              v-if="!isAdding"
              style="width: 4rem; justify-content: center; white-space: nowrap"
              variant="outline-secondary"
              @click="onCancel"
            >
              取消
            </BaseButton>
            <BaseButton
              style="width: 7.5rem; justify-content: center; white-space: nowrap"
              variant="primary"
              @click="onSubmit"
            >
              提交
            </BaseButton>
          </template>

          <!-- mobile view -->
          <template v-else>
            <BaseButton class="p-0" variant="none" @click="onSubmit">
              <div style="min-width: 3.5rem; display: flex; flex-direction: column">
                <img src="@/assets/img/icon/mobile-check.svg" height="36" alt="more" />
                <span style="color: #3596F4; font-size: 0.75rem; white-space: nowrap">
                  提交
                </span>
              </div>
            </BaseButton>
          </template>
        </template>

        <NotificationActionConfirmModal
          v-model="approval"
          :onNotificationStatusUpdate="onNotificationStatusUpdate$"
          :loading="loading"
        ></NotificationActionConfirmModal>
        <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
      </template>
    </div>

    <!-- second row -->
    <!-- admin VIEWING button group mobile view -->
    <div
      v-if="role === 'admin' && currState === STATES.VIEWING && isMobile"
      style="width: 100%; height: 2.75rem; display: flex"
    >
      <BaseButton
        variant="none"
        style="flex: 1; display: flex; justify-content: center"
        @click="onEdit"
      >
        <img src="../../assets/img/icon/edit.svg" alt="add" />
        <span class="ml-1">編輯</span>
      </BaseButton>
      <div style="border-left: 1px solid #CED4D9"></div>
      <BaseButton
        variant="none"
        style="flex: 1; display: flex; justify-content: center"
        @click="prepareAction('REMOVE', '你已移除這個紀錄')"
      >
        <img src="../../assets/img/icon/remove.svg" alt="remove" />
        <span class="ml-1">移除</span>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import ButtonLeftArrow from '@/components/button/ButtonLeftArrow.vue';
import ButtonRemove from '@/components/button/ButtonRemove.vue';
import NotificationActionConfirmModal from '@/components/notification/NotificationActionConfirmModal.vue';
import controlBarMixin from '@/mixins/control-bar';
import isMobileMixin from '@/mixins/is-mobile';
import { switchMap, tap } from 'rxjs/operators';
import http from '../../helpers/http';

// copied from EditNotification.vue
const STATES = Object.freeze({
  VIEWING: 0,
  EDITING: 1,
  PREVIEWING: 2,
});

export default {
  mixins: [controlBarMixin, isMobileMixin],
  components: {
    ActionSuccessModal,
    ButtonLeftArrow,
    ButtonRemove,
    NotificationActionConfirmModal,
  },
  props: {
    role: String,
    fromRoute: Object,
    deletedBy: String,
    title: String,
    currState: {
      type: Number,
      required: true,
    },
    isAdding: {
      type: Boolean,
      required: true,
    },
    isBlog: {
      type: Boolean,
      required: true,
    },
    isEdm: {
      type: Boolean,
      required: true,
    },
    isDraft: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    STATES,
    approval: {
      modal: false,
      action: null,
      remarks: null,
    },
    loading: false,
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/notification',
        text: '返回最新消息',
      },
    },
  }),
  domStreams: ['onNotificationStatusUpdate$'],
  subscriptions() {
    return {
      notificationStatusUpdate: this.onNotificationStatusUpdate$.pipe(
        tap(() => {
          this.loading = true;
        }),
        switchMap(() => {
          const { action, msg } = this.approval;
          return http(
            {
              method: 'POST',
              url: '/agc-admin-api/notification/remove',
              data: {
                id: this.inputVal.id,
                deletedBy: this.deletedBy,
              },
            },
            {
              next: () => {
                if (msg) {
                  this.actionSuccessModal = {
                    ...this.actionSuccessModal,
                    show: true,
                    action,
                    msg,
                  };
                }
              },
              complete: () => {
                this.approval.modal = false;
                this.loading = false;
              },
            },
          );
        }),
      ),
    };
  },
  methods: {
    goBackHistory() {
      if (this.fromRoute?.name) {
        this.$router.go(-1);
      } else {
        this.$router.push({ path: this.role === 'merchant' ? '/notification' : `/${this.role}/notification` });
      }
    },
    onBack() {
      switch (this.currState) {
        case STATES.VIEWING:
          this.goBackHistory();
          break;
        case STATES.EDITING:
          if (this.isMobile && !this.isAdding) {
            this.$emit('cancel-click');
          } else {
            this.goBackHistory();
          }
          break;
        case STATES.PREVIEWING:
          this.$emit('cancel-preview-click');
          break;
        default:
          break;
      }
    },
    onCancel() {
      switch (this.currState) {
        case STATES.EDITING:
          this.$emit('cancel-click');
          break;
        case STATES.PREVIEWING:
          this.$emit('cancel-preview-click');
          break;
        default:
          break;
      }
    },
    onSubmit() {
      switch (this.currState) {
        case STATES.EDITING:
          if (this.isDraft) {
            if (this.isAdding) {
              this.$emit('submit-click');
            } else {
              this.$emit('resubmit-click');
            }
          } else {
            this.$emit('preview-click');
          }
          break;
        case STATES.PREVIEWING:
          if (this.isAdding) {
            this.$emit('submit-click');
          } else {
            this.$emit('resubmit-click');
          }
          break;
        default:
          break;
      }
    },
    async prepareAction(action, msg) {
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/variables";
::v-deep .approval-modal {
  &__header {
    border-bottom: none;
  }
}

// from BaseControlBar
.section-header {
  position: sticky;
  top: $toolbar-height;
  background: #fafdff;
  z-index: 30;
  min-height: 65px !important;

  @include respond(tab-landscape) {
    top: 0px;
    padding: 0;
  }
}
</style>
